/* jshint browser:true,newcap:false */
/* global kx:true */

(function(window, kx) {

})(window, kx);
